import {MEMBERS_AREA} from '@wix/app-definition-ids';

export const BLOCKS_PRODUCT_PAGE_APP_DEF_ID = 'a0c68605-c2e7-4c8d-9ea1-767f9770e087';
export const APP_INSTALLED_ACTION = 'appInstalled';
export const MEMBERS_AREA_APP_DEF_ID = MEMBERS_AREA;
export const HARMONY_SUBTYPE = 'EDITOR3';
export const STUDIO_SUBTYPE = 'STUDIO';
export const X_SUBTYPE = 'EDITOR_X';
export const STUDIO_BRAND = 'studio';

export enum FedopsInteractions {
  StoresInstallationEditorReady = 'stores-installation-editor-ready-finished',
  StoresAppManifestCompletion = 'stores-app-manifest-completion',
  StoresInstallationAppInstalled = 'stores-installation-app-installed',
  CategoryRolloutManagerStatusCall = 'category-rollout-manager-status-call',
  StoresPagesStatusCheck = 'stores-pages-status-check',
  StoresPagesInstallationProcess = 'stores-pages-installation-process',
  BlocksProductPageAppInstallation = 'blocks-product-page-app-installation',
  ProductAddOoiPage = 'ooi-product-page-add-page',
  MigrateToOoiProductPage = 'migrate-to-ooi-product-page',
  MigrateToOoiProductPageConfirmation = 'migrate-to-ooi-product-page-confirmation',
  MigrateToOoiProductPageExecution = 'migrate-to-ooi-product-page-execution',
  CategoryPageAndRouterInstallationProcess = 'category-page-page-and-router-installation-process',
  CategoryAddPage = 'category-page-add-page',
  CategoryPageCheckIfAlreadyExists = 'category-page-check-if-already-exists',
  CategoryAddRouter = 'category-page-add-router',
  CategoryConnectRouter = 'category-page-connect-router',
  CategoryAddPageToSiteMenu = 'category-page-add-page-to-site-menu',
}

export enum MigrateActions {
  FixCategoryPage = 'FixCategoryPage',
  ReinstallCategoryPage = 'ReinstallCategoryPage',
  FixBlocksProductPage = 'FixBlocksProductPage',
  MigrateToOoiProductPage = 'MigrateToOoiProductPage',
  AnalyzeStoresInstallation = 'AnalyzeStoresInstallation',
  FixProductPageFontStyleParams = 'FixProductPageFontStyleParams',
}

export enum AppReflowPageVariantID {
  DuplicateOriginalProductPage = 'DuplicateOriginalProductPage',
  DuplicateOriginalCategoryPage = 'DuplicateOriginalCategoryPage',
  StartFromBlankProductPage = 'StartFromBlankProductPage',
  StartFromBlankCategoryPage = 'StartFromBlankCategoryPage',
  DuplicateVariantProductPage = 'DuplicateVariantProductPage',
  DuplicateVariantCategoryPage = 'DuplicateVariantCategoryPage',
}

export enum AppReflowPremiumFeatureName {
  CategoryPage = 'multiple_category_pages',
  ProductPage = 'multiple_product_pages',
}
